import moment from "moment";
import { SENTIMENT_ACTION } from "./actions";
import { IData } from "../web/common";

const DATA_COUNT = 90;
const COLLECTION_NAME = "NS_XU030_DAILY";

interface IXUData {
  xu30Daily: IData[];
  requested: boolean;
  loaded: boolean;
}

const initialState: IXUData = {
  xu30Daily: [],
  requested: false,
  loaded: false,
};

export function loadXu30Daily(firebase: any) {
  return async function thunk(dispatch: any, getState: any) {
    const state = getState();
    if (state.XU30Daily.requested) return;
    dispatch({
      type: SENTIMENT_ACTION.XU030_DAILY,
      payload: { requested: true, loaded: false, sentiment: [] },
    });

    firebase
      .firestore()
      .collection(COLLECTION_NAME)
      .orderBy("dateTime", "desc")
      .limit(DATA_COUNT)
      .onSnapshot((querySnapshot: any) => {
        var xu030Data: Object[] = [];

        querySnapshot.forEach(function (doc: any) {
          const dateVal = moment
            .unix(doc.data().dateTime.seconds)
            .format("YYYY/MM/DD");
          xu030Data.push({
            name: "close",
            close: doc.data().close,
            net: doc.data().net,
            dateTime: doc.data().dateTime.toDate(),
          });
        });

        xu030Data = xu030Data.reverse();

        dispatch({
          type: SENTIMENT_ACTION.XU030_DAILY,
          payload: {
            xu30Daily: xu030Data,
            loaded: true,
            requested: true,
          },
        });
      });
  };
}

export default function XU30Daily(state = initialState, action: any) {
  switch (action.type) {
    case SENTIMENT_ACTION.XU030_DAILY:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
export const xu30DailySelector = (state: any) => state.XU30Daily;
